<template>
  <div>
    <v-container>
      <h1 class="text-h4 light--text font-weight-light">Ubiquity Internet Self Sign-up.</h1>
      <h1 class="text-h5 lighterOrange--text font-weight-light">
        If you have a link, please paste it in the address bar.
      </h1>
      <h1 class="text-h6 lightGreen--text font-weight-light">
        Thank you for choosing Ubiquity Internet.
      </h1>
    </v-container>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>